/* tslint:disable */
/* eslint-disable */
/**
 * LPPSWebApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { formatDateOnly, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SyncContactResponse
 */
export interface SyncContactResponse {
    /**
     * 
     * @type {string}
     * @memberof SyncContactResponse
     */
    contactId: string;
    /**
     * 
     * @type {string}
     * @memberof SyncContactResponse
     */
    fullName: string | null;
    /**
     * 
     * @type {string}
     * @memberof SyncContactResponse
     */
    email: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof SyncContactResponse
     */
    isNewContact?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof SyncContactResponse
     */
    roles?: Array<string> | null;
}

/**
 * Check if a given object implements the SyncContactResponse interface.
 */
export function instanceOfSyncContactResponse(value: object): value is SyncContactResponse {
    if (!('contactId' in value) || value['contactId'] === undefined) return false;
    if (!('fullName' in value) || value['fullName'] === undefined) return false;
    if (!('email' in value) || value['email'] === undefined) return false;
    return true;
}

export function SyncContactResponseFromJSON(json: any): SyncContactResponse {
    return SyncContactResponseFromJSONTyped(json, false);
}

export function SyncContactResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SyncContactResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'contactId': json['contactId'],
        'fullName': json['fullName'],
        'email': json['email'],
        'isNewContact': json['isNewContact'] == null ? undefined : json['isNewContact'],
        'roles': json['roles'] == null ? undefined : json['roles'],
    };
}

export function SyncContactResponseToJSON(json: any): SyncContactResponse {
    return SyncContactResponseToJSONTyped(json, false);
}

export function SyncContactResponseToJSONTyped(value?: SyncContactResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'contactId': value['contactId'],
        'fullName': value['fullName'],
        'email': value['email'],
        'isNewContact': value['isNewContact'],
        'roles': value['roles'],
    };
}

